import { useAccount, useEthWallets } from "@/react/hooks";
import { OptionButton } from "@/react/components/OptionButton";
import { routes, useSimpleKitContext } from "@/react/context/SimpleKitContext";
import { NetworkSymbols } from "based-auth/networks";
import { useEffect } from "react";

// function ETHWalletOption({
//   index,
//   connector,
// }: {
//   index: number;
//   connector: any;
// }) {
//   const { setPendingItem, setRouter } = useSimpleKitContext();
//   const [ready, setReady] = useState(false);

//   useEffect(() => {
//     (async () => {
//       if (connector.getProvider) {
//         await connector.getProvider();
//       } else if (connector.connecting) {
//         await new Promise<void>((resolve) => {
//           const interval = setInterval(() => {
//             if (!connector.connecting) {
//               clearInterval(interval);
//               resolve();
//             }
//           }, 1000);
//         });
//       }
//       setReady(true);
//     })();
//   }, []);

//   if (!ready) {
//     return <WalletSkeleton />;
//   }

//   return (
//     <OptionButton
//       index={index}
//       className="web3kit-w-full"
//       logo={connector.logo}
//     >
//       <div className="web3kit-text-lg">{connector.name}</div>
//     </OptionButton>
//   );
// }

export function SelectETHWallet() {
  const { setPendingItem, setRouter } = useSimpleKitContext();
  const { users } = useAccount();
  const { data: ethWallets } = useEthWallets();

  useEffect(() => {
    setPendingItem(null);
  }, []);

  return (
    <div className="web3kit-space-y-2">
      {ethWallets
        .filter(
          (wallet: any) =>
            !users.find(
              (user: any) =>
                user.provider === wallet.id &&
                user.network === NetworkSymbols.eth
            )
        )
        .map((wallet: any, index: number) => (
          <OptionButton
            key={wallet.id}
            index={index}
            logo={wallet.icon}
            onClick={() => {
              setRouter(() => {
                setPendingItem({
                  id: wallet.id,
                  logo: wallet.icon,
                  network: NetworkSymbols.eth,
                  description: `Open the ${wallet.name} browser extension to connect your wallet.`,
                });
                return routes.walletConnecting;
              });
            }}
          >
            {wallet.name}
          </OptionButton>
        ))}
    </div>
  );
}
